module.exports = __webpack_public_path__ + "img/notcommiteddate.6ed1502b.svg";